import React from "react";
import ReactDOM from "react-dom";
import Rota from "./Rota";
import { inicializarFirebase } from "./push-notification";

import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery";

import "bootstrap/dist/js/bootstrap.bundle.min";

import { library } from "@fortawesome/fontawesome-svg-core";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";

library.add(faStroopwafel);
//import App from "./App.js";
//import { createBrowserHistory } from "history";
//const history = createBrowserHistory();
require("dotenv").config();

ReactDOM.render(<Rota />, document.getElementById("root"));
inicializarFirebase();
serviceWorker.register();
